import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';

const propTypes = {
  initialValue: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array,
  style: PropTypes.object,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.object,
};

const defaultProps = {
  initialValue: [],
  options: [],
  style: {},
  className: '',
};

export const TagsSelector = (props) => {
  const { initialValue, style, className, placeholder, options, onChange } = props;
  const [selectedItems, setSelectedItems] = useState([]);

  useEffect(() => {
    if (initialValue.length > 0) {
      const initialTags = options.filter((o) => initialValue.includes(o._id));
      const initialOptions = initialTags.map((tag) => ({ key: tag._id, label: tag.title }));
      setSelectedItems(initialOptions);
    } else {
      setSelectedItems([]);
    }
  }, [initialValue, options]);

  const handleChange = (selectedItems) => {
    onChange(selectedItems);
    setSelectedItems(selectedItems);
  };

  const selectedIds = selectedItems.map((item) => item.key);
  const filteredOptions = options.filter((o) => !selectedIds.includes(o._id));

  const filterOption = (input, { props }) => {
    const name = props.children.toLowerCase();
    const fullArr = [name];
    return fullArr.some((el) => el.indexOf(input.toLowerCase()) > -1);
  };

  return (
    <Select
      showSearch
      mode="multiple"
      placeholder={placeholder || 'Select tags'}
      value={selectedItems}
      labelInValue
      onChange={handleChange}
      className={className || 'full-width'}
      style={style}
      optionFilterProp="label"
      optionLabelProp="label"
      filterOption={filterOption}
    >
      {filteredOptions.map(
        (tag) =>
          tag._id &&
          tag.title && (
            <Select.Option key={tag._id} value={tag._id} label={tag.displayTitle ?? tag.title}>
              {tag.displayTitle ?? tag.title}
            </Select.Option>
          )
      )}
    </Select>
  );
};

TagsSelector.propTypes = propTypes;
TagsSelector.defaultProps = defaultProps;

export default TagsSelector;
